// extracted by mini-css-extract-plugin
module.exports = {"banner":"banner___30mvG","actions":"actions___3iw45","tagline":"tagline___sYzSU","body":"body___2qhew","subtitle":"subtitle___1EsnF","copy":"copy___3cdR1"};